import { extractBaseDomain } from './extractDomainName'

interface ExternalCookieKeyValue {
  source_url?: string
  landing_page_url?: string
}
export const formatUrlforUtms = (
  urlString: string,
  externalCookieKeyValue?: ExternalCookieKeyValue,
): Record<string, string> => {
  const paramString = urlString?.split('?')[1]
  const { source_url = '', landing_page_url = '' } = externalCookieKeyValue || {}
  const srcUrlDomain = source_url ? extractBaseDomain(source_url) ?? '' : ''
  const utmHash = {
    sourceUrl: srcUrlDomain,
    landingPageUrl: landing_page_url || '',
  }
  const queryString = new URLSearchParams(paramString)
  if (paramString || queryString?.size) {
    for (const pair of queryString?.entries()) {
      const splitUnderScore = pair[0]?.split('_')
      for (let currentIndex = 1; currentIndex < splitUnderScore?.length; currentIndex++) {
        splitUnderScore[currentIndex] =
          splitUnderScore[currentIndex]?.charAt(0)?.toUpperCase() +
          splitUnderScore[currentIndex]?.slice(1)
      }
      const utmKey = splitUnderScore?.join('')
      utmHash[utmKey] = pair[1] || ''
    }
    utmHash['isUtmParams'] = true
  }
  return utmHash
}

export const manipulateUtm = (): Record<string, string> => {
  const urlString = window?.location?.href || ''
  return formatUrlforUtms(urlString)
}
